import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const StockBreakdownPopup = ({ onClose, currentStockId, fromHistory }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [popupData, setPopupData] = useState(currentStockId);
  const [popupDataTable, setPopupDataTable] = useState(
    currentStockId.individual_users
  );

  const formatDate = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-4xl p-6 max-h-[90vh]  overflow-y-auto rounded-lg shadow-lg relative">
        {/* Header */}
        <div className="flex items-center text-center justify-between pb-4 mb-4 relative">
          {/* Header Text */}
          <h2 className="text-sm md:text-xl font-semibold text-center w-full flex-1 md:w-auto break-words">
            {popupData.stock_name}
          </h2>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-0 right-4 md:relative md:top-auto md:right-auto text-gray-500 hover:text-black text-lg"
          >
            <img src="/add.svg" alt="Close" className="w-6 h-6 md:w-8 md:h-8" />
          </button>
        </div>

        {/* Table */}
        {popupDataTable && (
          <div className="overflow-x-auto max-h-[70vh]  font-medium overflow-y-auto mb-6">
            <table className="table-auto w-full border rounded border-gray-300">
              <thead>
                <tr className="text-[#005A9C] text-xs">
                  <th className="px-4 py-2 border bg-[#FDF4FF]">No</th>
                  <th className="px-4 py-2 border">Client Name</th>
                  <th className="px-4 py-2 border">Client ID</th>
                  <th className="px-4 py-2 border">Product Name</th>
                  {fromHistory && (
                    <th className="px-4 py-2 border">
                      No of Shares Purchased ({popupData.number_of_shares})
                    </th>
                  )}
                  {!fromHistory && (
                    <>
                      <th className="px-4 py-2 border">
                        No of Shares Purchased (
                        {popupData.shares_to_be_purshaed})
                      </th>
                      <th className="px-4 py-2 border">
                        No of Shares Sold ({popupData.shares_to_be_sold})
                      </th>
                      <th className="px-4 py-2 border">Type</th>
                    </>
                  )}
                  <th className="px-4 py-2 border">Cash Account</th>
                  <th className="px-4 py-2 border">Time of Request</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(7)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm">
                  {popupDataTable.map((row, index) => (
                    <tr key={index}>
                      <td className="px-4 py-2 border  bg-[#FDF4FF]">
                        {String(index).padStart(2, "0")}
                      </td>
                      <td className="px-4 py-2 border">{row.client_name}</td>
                      <td className="px-4 py-2 border">{row.client_id}</td>
                      <td className="px-4 py-2 border">{row.product_name}</td>
                      {fromHistory && (
                        <td className="px-4 py-2 border">
                          {row.number_of_shares}
                        </td>
                      )}

                      {!fromHistory && (
                        <>
                          {" "}
                          <td className="px-4 py-2 border">
                            {row.type && row.type == "buy"
                              ? row.number_of_shares
                              : 0}
                          </td>
                          <td className="px-4 py-2 border">
                            {row.type && row.type == "sell"
                              ? row.number_of_shares
                              : 0}
                          </td>
                          <td className="px-4 py-2 border">
                            {row.type
                              ? row.type.charAt(0).toUpperCase() +
                                row.type.slice(1)
                              : "Purchased"}
                          </td>
                        </>
                      )}

                      <td className="px-4 py-2 border">
                        {(row.cash_account_balance == null
                          ? 0
                          : row.cash_account_balance
                        )
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>
                      <td className="px-4 py-2 border">
                        {formatDate(row.time_of_request)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockBreakdownPopup;
